<template>
  <div v-if="shopData && shopData.length > 0" v-loading="loading" element-loading-text="拼命加载中..." class="home-shop-data">
    <div class="home-shop-data__title">店铺数据</div>
    <el-carousel ref="carousel" :autoplay="false" :loop="false" trigger="click" height="394px" dark>
      <el-carousel-item v-for="(item, index) in shopData" :key="index" class="home-shop-data__item">
        <ShopDataItem v-for="(v, i) in item" :key="i" :shop-data-item="v"/>
      </el-carousel-item>
    </el-carousel>
    <el-pagination
      small
      :page-size="SHOP_PAGE_NUM"
      :total="pageTotal"
      :current-page="currentPage"
      class="home-shop-data__pagination"
      @current-change="handlePageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import shopList from '../../../api/apis/home';
import ShopDataItem from './shopDataItem.vue';
import { SHOP_PAGE_NUM } from '../../../config/index';

export default {
  name: 'ShopData',
  components: {
    ShopDataItem,
  },
  data() {
    return {
      SHOP_PAGE_NUM,
      currentPage: 1,
      pageTotal: 0,
      shopData: [],
      loading: false,
    };
  },
  async created() {
    this.getShopData();
  },
  methods: {
    async getShopData() {
      try {
        this.loading = true;
        const shopData = await shopList();
        if (shopData.code === 200) {
          this.currentPage = 1;
          const len = shopData.data.content.length;
          const num = Math.ceil(len / 3);
          for (let i = 0; i < num; i++) {
            this.shopData.push(shopData.data.content.slice(i * SHOP_PAGE_NUM, (i * SHOP_PAGE_NUM) + SHOP_PAGE_NUM));
          }
          this.pageTotal = len;
          this.loading = false;
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(error || '获取店铺数据失败');
      }
    },
    handlePageChange(index) {
      if (window.log) {
        window.log('shopdata_change', '01');
      }
      this.currentPage = index;
      this.$refs.carousel.setActiveItem(index - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-shop-data {
  margin-top: 20px;
  padding: 20px 20px 16px;
  background: rgba(255,255,255,1);
  border-radius: 4px;
  .home-shop-data__title {
    margin-bottom: 30px;
    line-height: 18px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  .home-shop-data__item {
    display: flex;
  }
  .home-shop-data__pagination {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
::v-deep.home-shop-data .el-carousel__arrow {
  height: 0;
  width: 0;
  opacity: 0;
}
::v-deep.home-shop-data .el-carousel__indicators {
  width: 0;
  opacity: 0;
}
</style>
